import type { User } from "firebase/auth";

/**
 * Conta admin/dono do produto. `isAdminAccessAllowed`/`isAdminEmail` são usados tanto para
 * liberar recursos premium/profissionais quanto — em web/src/App.tsx (`Main`, via
 * `isProfessionalAccessBypassed`) — para PULAR o gate de e-mail não verificado
 * (`requiresEmailVerificationAccess`). Ou seja, esta conta nunca vê a tela "Confirme seu
 * e-mail", independentemente de `emailVerified`. Bypass intencional, preservado por decisão
 * do time; qualquer alteração aqui afeta esse comportamento também.
 */
export const ADMIN_EMAIL = "jessediasmunizjunior@gmail.com";

type AdminProfileLike = {
  role?: string;
  accessLevel?: string;
  email?: string;
} | null | undefined;

type AdminClaimsLike = Record<string, unknown> | null | undefined;

export function isAdminEmail(email?: string | null): boolean {
  return String(email ?? "").trim().toLowerCase() === ADMIN_EMAIL;
}

export async function getAdminAccessClaim(user?: User | null): Promise<boolean> {
  if (!user) return false;
  return isAdminEmail(user.email);
}

export function isAdminAccessAllowed(
  email?: string | null,
  _profile?: AdminProfileLike,
  _claims?: AdminClaimsLike
): boolean {
  return isAdminEmail(email);
}
